<script setup lang="ts">
import { APP_URL } from '~/constants';
import { PageNormalTop } from '~/features/ranking';

const route = useRoute();
useHead(() => ({
  link: [
    {
      rel: 'canonical',
      href: APP_URL + route.path,
    },
  ],
  meta: [
    {
      name: 'robots',
      content: 'all',
    },
  ],
}));
</script>
<template>
  <div>
    <PageNormalTop />
  </div>
</template>
